<template>
  <div class="animated fadeIn" id="train-template">
    <b-row class="email-app">
      <b-col lg="12">
        <main class="message bg-primary" v-if="!editorDataLoaded">
          <div>
            <strong>{{ $t('TEMPLATE.TRAIN_BASE') }}</strong>
          </div>
        </main>
        <b-card v-if="!editorDataLoaded">
          <content-placeholders >
            <content-placeholders-img style="height: 765px"/>
            </content-placeholders>
        </b-card>
        <div class="pull-right" v-if="editorDataLoaded && trainTemplate.is_public">
          <b-button class="mt-2" variant="secondary" target="_blank" :href="'/submit/'+trainTemplate.template_doc_id">Submit Form</b-button>
        </div>
        <main class="message bg-primary">
        <div v-if="editorDataLoaded">
          <strong> {{ $t('TEMPLATE.TRAIN_BASE') }}</strong> &nbsp; {{trainTemplate.title}}
          <span class="badge badge-info mr-4"> {{trainTemplate.status ? ('COMMON.DONE') : $t('COMMON.NEW') }} </span>
          <select v-if="trainTemplateData.revision_ids.length" v-model="revisionVersionSelected" @change="fetchTemplateWithOutGaurd($event.target.value)">
            <option v-for="(option, index) in trainTemplateData.revision_ids" v-bind:value="option" :key=index>
              {{ $t('COMMON.VERSION') }} {{ option }}
            </option>
          </select>
          <select v-else v-model="revisionVersionSelected">
            <option value="1">
              {{ $t('COMMON.VERSION') }} 1
            </option>
          </select>
          <label>{{ $t('TEMPLATE.ENABLE_AUTO_CORRECT') }}</label>
          <c-switch type="3d" variant="success" :checked="trainTemplate.auto_correct_flag" @change="autoCorrectSwitchChange($event)"/>
        <span class="up-dn-btn">
           <div class="btn-group import-export">
            <b-button class="import-export-button" :href="axios.defaults.baseURL.replace('/api', '') + trainTemplateData.image_url" target="_blank" ><i class="fa fa-download"></i></b-button>
          </div>
          <div v-if="isAdminRole" class="btn-group import-export">
            <b-button class="import-export-button" v-on:click="mappingDownload">{{$t('TEMPLATE.EXPORT')}}</b-button>
          </div>
          <div v-if="isAdminRole" class="btn-group import-export">
            <b-button class="import-export-button" v-on:click="showImportModal"> {{$t('TEMPLATE.IMPORT')}} </b-button>
          </div>
        </span>
          <span v-if="barCodePresent" class="float-right">
            <strong> Barcode: </strong> <span class="mr-4"> {{trainTemplate.barcodes[0].value}} </span>
            <strong> Barcode Type: </strong> {{trainTemplate.barcodes[0].barcode_type}}
            <span class="barcode-info" id="barcodeInfo" v-if="multipleBarCode" @click="toggleShowMoreBarcode">
              <b><i><u>{{ showMoreText }}</u></i></b>
            </span>
            <b-popover target="barcodeInfo" triggers="click">
              <template>
                  <b-table hover :fields="barcodeFields" :items="trainTemplate.barcodes"></b-table>
              </template>
            </b-popover>
          </span>
        </div>
        </main>
        <b-row>
          <b-col lg="3">
            <div class="template-mapping" v-if="!mappingDataLoaded">
              <main class="message">
              <b-card header-tag="header" footer-tag="footer">
                <div slot="header">
                  <i className="fa fa-align-justify"></i><strong>{{ $t('TEMPLATE.MAPPINGS') }}</strong>
                </div>
                <content-placeholders >
                  <content-placeholders-text :lines="29" />
                  </content-placeholders>
              </b-card>
              </main>
            </div>
            <template-mappings v-else v-bind:template-mappings="this.mappingsData" v-bind:mappings="this.stage" @updated="mappingUpdated" @nodeSelected="showEditNode" v-bind:is-latest-version="this.isLatestVersion"></template-mappings>
            <new-mapping v-bind:mappings-keys="this.mappingsKeys" v-bind:show-new-mapping="this.showNewMapping" v-bind:order-options="this.orderOptionsForNewMapping" @created="mappingCreated" @cancelled="mappingCancelled"></new-mapping>
            <new-grouping v-bind:mappings-keys="this.mappingsKeys" v-bind:show-new-grouping="this.showNewGrouping" v-bind:group-children="this.groupChildren" v-bind:order-options="this.orderOptionsForNewMapping" @created="groupCreated" @cancelled="groupCancelled"></new-grouping>
            <edit-mapping v-bind:mappings-keys="this.mappingsKeys" v-bind:show-edit-mapping="this.showEditMapping" v-bind:canvasElement="this.editShape" v-bind:npi-groups="this.npiGroups" v-bind:stage="this.stage" v-bind:order-options="this.orderOptionsForUpdateMapping" @updated="mappingUpdated" @cancelled="updateCancelled"></edit-mapping>
            <new-npiGrouping v-bind:mappings-keys="this.mappingsKeys" v-bind:show-new-npi-grouping="this.showNewNpiGrouping" v-bind:templateMappings="this.stage" @created="npiGroupCreated" @cancelled="npiGroupCancelled"></new-npiGrouping>
          </b-col>
          <b-col lg="9">
            <main class="message content-holder">
            <div class="d-flex justify-content-between toolbar-bg" v-if="editorDataLoaded">
              <div class="action-bar-row" v-if="this.isLatestVersion || !this.trainTemplateData.revision_ids.length">
                <div class="btn-group">
                  <b-button :variant="selectedAction('save')" :disabled="!this.enableSave()" @click="saveDataFunction" v-b-tooltip.hover :title="$t('TEMPLATE.SAVE')"><i class="fa fa-floppy-o"></i></b-button>
                </div>
                <div class="btn-group">
                  <b-button variant="light"  @click="toggleThumbnail" v-b-tooltip.hover :title="$t('TEMPLATE.THUMBNAIL')"><i class="fa fa-image"></i></b-button>
                </div>
                <b-dropdown variant="light" class="theme">
                  <template slot="button-content">
                    <span class="">{{ $t('TEMPLATE.THEME') }} </span>
                  </template>
                  <b-dropdown-item href="#" v-bind:class="{selected: isThemeSelected('blue')}" @click="updateTheme('blue')"> {{ $t('COLOR.BLUE') }} <b-badge variant="info"> {{ $t('COLOR.BLUE') }}</b-badge></b-dropdown-item>
                  <b-dropdown-item href="#" v-bind:class="{selected: isThemeSelected('green')}" @click="updateTheme('green')"> {{ $t('COLOR.GREEN') }} <b-badge variant="success"> {{ $t('COLOR.GREEN') }}</b-badge></b-dropdown-item>
                  <b-dropdown-item href="#" v-bind:class="{selected: isThemeSelected('red')}" @click="updateTheme('red')"> {{ $t('COLOR.RED') }} <b-badge variant="danger"> {{ $t('COLOR.RED') }}</b-badge></b-dropdown-item>
                </b-dropdown>
                <div class="btn-group">
                  <b-button variant="light" @click="showCreateNpiModal" v-b-tooltip.hover :title="$t('TEMPLATE.CREATE_NPI_GROUP')">{{ $t('TEMPLATE.NPI_GROUP') }}</b-button>
                </div>
              </div>
              <div class="older-version-message" v-else>
                <strong class="text-danger">{{ $t('TEMPLATE.OLDER_VERSIONS') }}</strong>
              </div>
              <div class="action-bar-row paginate-page">
                <b-button :title="$t('TEMPLATE.PREV_PAGE')" :variant="'link'" :disabled="canGoToPrev" @click="goToPage(prevPage)"><i class="fa fa-arrow-left" v-b-tooltip.hover></i></b-button>
                <span class="holder"><span class="h4">{{getCurrentPage}}</span> {{ $t('COMMON.OF') }} {{totalPages}}</span>
                <b-button :title="$t('TEMPLATE.NEXT_PAGE')" :variant="'link'" :disabled="canGoToNext" @click="goToPage(nextPage)" ><i class="fa fa-arrow-right" v-b-tooltip.hover></i></b-button>
              </div>
              <div class="action-bar-row" v-if="this.isLatestVersion || !this.trainTemplateData.revision_ids.length">
                <div v-if="isAdminRole" class="btn-group">
                  <b-button :variant="selectedAction('select')" @click="enableSelection" v-b-tooltip.hover :title="$t('TEMPLATE.SELECT')" ref="selectIcon"><i class="fa fa-mouse-pointer"></i></b-button>
                  <b-button :variant="selectedAction('draw')" @click="enableDraw" v-b-tooltip.hover :title="$t('TEMPLATE.DRAW')" ref="drawIcon"><i class="fa fa-pencil"></i></b-button>
                </div>
                <div class="btn-group">
                  <b-button variant="light" @click="zoomIn"><i class="fa fa-search-plus" v-b-tooltip.hover :title="$t('TEMPLATE.ZOOM_IN')"></i></b-button>
                  <b-button variant="light" @click="zoomOut"><i class="fa fa-search-minus" v-b-tooltip.hover :title="$t('TEMPLATE.ZOOM_OUT')"></i></b-button>
                </div>
                <div v-if="isAdminRole" class="btn-group">
                  <b-button :disabled="!enableUndo" variant="light" @click="undo" v-b-tooltip.hover :title="$t('TEMPLATE.UNDO')"><i class="fa fa-undo"></i></b-button>
                  <b-button :disabled="!enableRedo" variant="light" @click="redo" v-b-tooltip.hover :title="$t('TEMPLATE.REDO')"><i class="fa fa-repeat"></i></b-button>
                </div>
                <div v-if="isAdminRole" class="btn-group">
                  <b-button :disabled="!canDelete" :variant="selectedAction('delete')" @click="showDeleteModal" v-b-tooltip.hover :title="$t('TEMPLATE.DELETE_MAP')"><i class="fa fa-trash"></i></b-button>
                </div>
              </div>
              <div v-else>
              </div>
            </div>

            <transition name="fade">
            <b-card v-if="showThumbnail" class="thumbnail-holder">
              <div class="scrolling-wrapper-flexbox">
                <b-card v-for="(thumbnail, index) in this.trainTemplateData.doc_thumbnails"
                        :class="{ 'thumbnail-card shadow': true, 'thumbnail-selected': thumbnailSelected(thumbnail['id']) }"
                        :key="thumbnail['id']" @click="goToPage(index)">
                  <img :src="thumbnail['url'] | withBaseUrl" class="card-img-top" />
                  <div class="page-number"><h4>{{index + 1}}</h4></div>
                </b-card>
              </div>
            </b-card>
            </transition>

            <div class="details">
              <div class="content">
                <b-card><div id="container" ref="canvasEditor" class="hidden_cn" :class="{draw_mode: this.draw}" :style="{ maxHeight: this.containerHeight + 'px' }"> <!-- Konva will canvas here --> </div></b-card>
                <new-mapping></new-mapping>
              </div>
            </div>
            </main>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <context-menu v-bind:viewMenu="this.viewMenu"
      v-bind:disableCut="this.contextMenu.cut.disabled"
      v-bind:disableCopy="this.contextMenu.copy.disabled"
      v-bind:disablePaste="this.contextMenu.paste.disabled"
      v-bind:disableDelete="this.contextMenu.destroy.disabled"
      v-bind:pageX="this.pageX"
      v-bind:pageY="this.pageY"
      @cut="cutShape"
      @copy="copyShape"
      @paste="pasteShape"
      @delete="destroyShape">
    </context-menu>

    <b-modal :title="$t('TEMPLATE.UNSAVE')" ref="saveAlertModal" :ok-title="$t('COMMON.YES')" :cancel-title="$t('COMMON.NO')" @ok="saveDataFunction()" @cancel="discardData()" ok-variant="secondary" cancel-variant="light" hide-header-close centered>
      {{$t('TEMPLATE.SAVE_CHANGES')}}
    </b-modal>
    <b-modal title='Delete Group' ref="deleteGroupModal" ok-title='Delete' cancel-title='Cancel' @ok="deleteGroup" @cancel="cancelDeleteGroup" ok-variant="secondary" cancel-variant="light" @hide="cancelDeleteGroup" hide-header-close centered>
      <b-row class="mb-3" v-if="deletableChildren.length > 0">
        <b-col cols="12">
          <h6 class="pull-left select-mappings">{{$t('COMMON.MSG_SELECT_CHILD')}}</h6>
        </b-col>
        <b-col cols="12">
          <input class="pull-left mt-1 mr-2" type="checkbox" id='delete_all' v-model="deleteAll" v-on:change="selectAllDeletableChildren" />
          <label class="pull-left" for='delete_all'>
            Delete All
          </label>
        </b-col>
        <b-col cols="6" v-for="child in deletableChildren" :key="child.attrs.path">
          <input class="pull-left mt-1 mr-2" type="checkbox" :id="child.attrs.uniq_id" :value="child.attrs.uniq_id" v-model="selectedDeletableChildren">
          <label class="pull-left" :for="child.attrs.uniq_id">
            {{child.attrs.key}} {{ child.attrs.map_type === 'shape' ? null : `( ${child.attrs.map_type} )`}}
          </label>
        </b-col>
      </b-row>
    </b-modal>

     <b-modal class="import-export-modal" id="modal" ref="importModal" :title="$t('TEMPLATE.UPLOAD_MAPPINGS')">
        <input id="fileUpload" type="file" ref="file" v-on:change="handleFileUpload()">
        <div slot="modal-footer">
          <b-btn size="sm" variant="secondary" @click="saveImportMappings" :disabled="!isFileSelected"> {{ $t('CONFIGURED.CREATE') }} </b-btn>
          <b-btn size="sm" variant="light" @click="hideImportModal"> {{ $t('COMMON.CLOSE') }} </b-btn>
        </div>
      </b-modal>
      <b-modal :title="$t('TEMPLATE.ESMMAPPINGS')" ref="updateEsmAlert" :ok-title="$t('COMMON.YES')" :cancel-title="$t('COMMON.NO')" @ok="saveData(update_esm_status, esm_status, sv_status, cv_status)" @cancel="dontSaveEsmData()" ok-variant="secondary" cancel-variant="light" hide-header-close centered>
      <p>{{$t('TEMPLATE.TEMPLATE_VERSION_UPDATE')}}</p>
      <p v-for="(status,index) in status_array" :key="status" class="text-left m-auto ml-md-auto">
       <b-row>
        <b-col cols="2"></b-col>
        <b-col cols="10">
          <p>{{index+1}}.{{status}}</p>
        </b-col>
       </b-row>
      </p>
    </b-modal>
    <b-modal :title="$t('TEMPLATE.DELETE_MODAL')" ref="deleteMappings" :ok-title="$t('COMMON.YES')" :cancel-title="$t('COMMON.NO')" @ok="deleteMapping()" @cancel="hideDeleteModal()" ok-variant="secondary" cancel-variant="light" hide-header-close centered>
      {{$t('TEMPLATE.DELETE_MODAL_CONTENT')}}
    </b-modal>
  </div>
</template>

<script>
import fetchTemplate from '@/components/mixins/Train/fetchTemplate'
import konvaCreator from '@/components/mixins/Train/konvaCreator'
import drawShape from '@/components/mixins/Train/drawShape'
import konvaEditor from '@/components/mixins/Train/KonvaEditor'
import populateMapping from '@/components/mixins/Train/populateMapping'
import konvaTransformer from '@/components/mixins/Train/konvaTransformer'
import zoom from '@/components/mixins/Train/zoom'
import tools from '@/components/mixins/Train/tools'
import contextMenu from '@/components/mixins/Train/contextMenu'
import keyBindings from '@/components/mixins/Train/keyBindings'
import editorHistory from '@/components/mixins/Train/editorHistory'
import themes from '@/components/mixins/Train/themes'
import utils from '@/components/mixins/Train/utils'
import mapComponent from './templateMappings'
import newMapping from './newMapping'
import newGrouping from './newGrouping'
import newNpiGrouping from './newNpiGrouping'
import templateMappings from '@/components/mixins/Train/templateMappings'
import groupMappings from '@/components/mixins/Train/groupMappings'
import groupShapes from '@/components/mixins/Train/groupShapes'
import konvaContextMenu from '@/components/templates/contextMenu'
import saveEditor from '@/components/mixins/Train/saveEditor'
import editMapping from '@/components/templates/editMapping'
import pagination from '@/components/mixins/Train/pagination'
import barcode from '@/components/mixins/Train/barcode'
import npiGroupMappings from '@/components/mixins/Train/npiGroupMappings'
import cSwitch from '@/components/Switch'
import Vue from 'vue'
import router from '../../router'
import { mapGetters } from 'vuex'

export default {
  name: 'train',
  data () {
    return {
      mappingData: null,
      file: '',
      text: '',
      info: '',
      imagename: '',
      imageFileName: '',
      mappingPayload: {},
      isFileSelected: false,
      update_esm_status: true
    }
  },
  mixins: [
    fetchTemplate,
    konvaCreator,
    drawShape,
    konvaEditor,
    populateMapping,
    konvaTransformer,
    zoom,
    tools,
    contextMenu,
    keyBindings,
    editorHistory,
    themes,
    utils,
    templateMappings,
    groupMappings,
    groupShapes,
    saveEditor,
    pagination,
    barcode,
    npiGroupMappings
  ],
  components: {
    'template-mappings': mapComponent,
    'new-mapping': newMapping,
    'new-grouping': newGrouping,
    'new-npiGrouping': newNpiGrouping,
    'context-menu': konvaContextMenu,
    'edit-mapping': editMapping,
    'c-switch': cSwitch
  },
  beforeRouteEnter: function (to, from, next) {
    next(vm => {
      if (to.query.version) {
        vm.fetchTemplateWithOutGaurd(to.query.version)
      }
      if (vm.isAdminRole) {
        next()
      } else {
        router.replace('/not-Found-404')
        Vue.toasted.show(vm.$t('COMMON.UNAUTHORIZED'), { icon: 'chain-broken', type: 'error' })
      }
    })
  },
  computed: {
    ...mapGetters(['isAdminRole']),
    orderOptionsForNewMapping: function () {
      return [...Array(this.updatedNoOfMappings + 1).keys()].map(index => index + 1)
    },
    orderOptionsForUpdateMapping: function () {
      return [...Array(this.updatedNoOfMappings).keys()].map(index => index + 1)
    }
  },
  methods: {
    autoCorrectSwitchChange: function (event) {
      this.trainTemplate.auto_correct_flag = event
      console.log('template_doc_id: ', this.trainTemplate)
      let apiData = new window.FormData()
      apiData.append('auto_correct_flag', this.trainTemplate.auto_correct_flag)
      apiData.append('template_doc_id', this.trainTemplate.template_doc_id)
      Vue.axios.post('template_docs/save_auto_correct_flag', apiData, { headers: { Authorization: `Bearer ${this.idToken}` } })
    },
    saveDataFunction () {
      if (this.update_revision_id_status && (this.esm_status || this.sv_status || this.cv_status)) {
        this.$refs.updateEsmAlert.show()
      } else {
        this.update_esm_status = false
        this.saveData(this.update_esm_status, this.esm_status, this.sv_status, this.cv_status)
      }
    },
    dontSaveEsmData () {
      this.$refs.updateEsmAlert.hide()
      this.update_esm_status = false
      this.saveData(this.update_esm_status, this.esm_status, this.sv_status, this.cv_status)
    },
    showDeleteModal () {
      this.$refs.deleteMappings.show()
    },
    hideDeleteModal () {
      this.$refs.deleteMappings.hide()
      this.canDelete = false
    },
    showImportModal () {
      this.$refs.importModal.show()
    },
    hideImportModal () {
      this.$refs.importModal.hide()
    },
    saveImportMappings () {
      Vue.axios.post('template_mappings/import_mappings', this.mappingPayload, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
          this.$refs.importModal.hide()
          if (!res.data.error) {
            router.go()
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    mappingDownload: function () {
      Vue.axios.get('template_mappings/export_mappings', { headers: { Authorization: `Bearer ${this.idToken}` }, params: { id: this.$route.params.id, revision_id: this.revisionVersionSelected } })
        .then(res => {
          this.mappingData = res
          const data = JSON.stringify(this.mappingData.data.mappings)
          const templateName = this.trainTemplate.title.replace(/\s+/g, '_')
          const filename = templateName + '_version' + this.revisionVersionSelected + '.txt'
          var element = document.createElement('a')
          element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data))
          element.setAttribute('Download', filename)
          element.style.display = 'none'
          document.body.appendChild(element)
          element.click()
          document.body.removeChild(element)
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
      this.isFileSelected = true
      const reader = new window.FileReader()
      reader.onload = evt => {
        this.text = JSON.parse(evt.target.result)
        let payload = {
          template_id: this.$route.params.id,
          revison_id: this.revisionVersionSelected,
          template_name: this.trainTemplate.title,
          mapping_data: this.text
        }
        this.mappingPayload = payload
      }
      reader.readAsText(this.file)
    }
  }
}
</script>

<style lang="scss" scoped>
.details .card-body {
  overflow: scroll;
  padding-top: 0.2rem;
}

.toolbar-bg { background-color: #EAEFF2; }
.card { background-color: #EAEFF2; }

.action-bar-row {
  display: inline-block;
  margin: 6px;
  text-align: center;
  .alert {
    padding: 0 50px;
    margin-bottom: 0;
  }
}

.import-export{
  float: right !important;
  margin-right: 10px;
}

.import-export-button{
  padding-top: 1px !important;
  padding-bottom: 1px !important;
  padding-left: 2px !important;
  padding-right: 2px !important;
  background-color: #fff;
  border-color: #fff;
  color: black;
}
.import-export-modal{
  color: black;
}

label {
  display: inline-block;
  padding-left: 5px;
  margin-bottom: 0rem;
  text-transform: capitalize;
  font-weight: bold;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.theme {
  .selected {
    background-color: #20a8d8;
  }
}

.draw_mode {
  cursor: crosshair;
}

main.message {
  text-transform: uppercase;
  margin: 0px -15px 1px -15px;
  padding: 15px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.paginate-page {
  .btn-link {
    color: black;

    &.disabled {
      color: #9fa1a3;
    }
  }
  span.holder {
    vertical-align: sub;
  }
}

.fa-arrow-left,
.fa-arrow-right {
  font-size: 16px;
  color: black;
}

.message {
  padding-bottom: 0;

  &.content-holder {
    padding-top: 10px;
  }
}

.scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;

  .card {
    flex: 0 0 auto;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.thumbnail-holder {
  margin-bottom: 0rem;
  padding: 0.5rem 1rem;
  .card-body {
    padding: 5px !important;
  }
}

.thumbnail-card {
  cursor: pointer;
  margin: 5px;
  margin-right: 2rem;

  .card-body {
    padding: 3px !important;
  }
}

.thumbnail-selected {
  border: solid 3px #20a8d8;
}

.page-number {
  position: absolute;
  z-index: 1;
  bottom: 0;
  right: 10px;
  opacity: 0.5;
}

.barcode-info {
  cursor: pointer;
}

.select-mappings {
  font-weight: 600;
  color: #1099c9;
}

.older-version-message{
  padding-top: 0.75rem;
  padding-left: 1.5rem;
}

</style>


// WEBPACK FOOTER //
// src/views/templates/Train.vue